import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Know Who <strong className="purple">I am</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <h1 className="project-heading">
          Languages, Libraries and Frameworks I <strong className="purple">Learn </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Techstack iconName="devicon-python-plain" />
          <Techstack iconName="devicon-flask-original" />
          <Techstack iconName="devicon-tensorflow-original" />
          <Techstack iconName="devicon-pandas-original " />
          <Techstack iconName="devicon-numpy-original" />
          <Techstack iconName="devicon-cplusplus-plain" />
          <Techstack iconName="devicon-mysql-plain" />
          <Techstack iconName="devicon-microsoftsqlserver-plain" />
          <Techstack iconName="devicon-mongodb-plain" />
          <Techstack iconName="devicon-javascript-plain " />
        </Row>
        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Techstack iconName="cib-visual-studio-code" />
          <Techstack iconName="cib-anaconda" />
          <Techstack iconName="cib-postman" />
          <Techstack iconName="devicon-pycharm-plain" />
          <Techstack iconName="devicon-docker-plain" />
          <Techstack iconName="devicon-jupyter-plain" />
          <Techstack iconName="devicon-git-plain-wordmark" />
        </Row>
        <h1 className="project-heading">
          <strong className="purple">Text Editors</strong> I use
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Techstack iconName="cib-visual-studio-code" />
          <Techstack iconName="cib-sublime-text" />
        </Row>
      </Container>
    </Container>
  );
}

export default About;
